<template>
  <div class="row">
    <div class="col-md-12">
      <form v-on:submit.prevent="submit">
        <buttons top />
      </form>
    </div>
    <div class="col-md-12">
      <form v-on:submit.prevent>
        <h4>Key Statistics</h4>
        <p>Please enter key statistics associated with the provider.</p>
        <hr />
        <keyStats
          :show="[
            'assetsUnderManagment',
            'minimumInvestment',
            'maximumInvestment',
            'avgAmountRaised',
            'numberOfInvestments',
            'timeToExitInDays',
            'timeToExitInYears',
            'successRate',
            'averageIrrSought',
            'boardSeat',
            'femaleFocus'
          ]"
        />
      </form>
    </div>
    <div class="col-md-12">
      <form v-on:submit.prevent>
        <h4>Descriptions</h4>
        <p>
          Please enter any relevant facts associated to the provider.
          <small><i>(In each case less than 500 characters)</i></small>
        </p>
        <hr />
        <keyDescs
          :show="[
            'exitSought',
            'investorVision',
            'investorFundingGoals',
            'region',
            'entrepreneurialExperience',
            'technicalExperience',
            'additionalServices',
            'applicationProcess'
          ]"
        />
      </form>
    </div>
    <div class="col-md-12">
      <form v-on:submit.prevent="submit">
        <buttons />
      </form>
    </div>
  </div>
</template>

<script>
import keyStats from "../elements/stats.vue";
import keyDescs from "../elements/descs.vue";
import buttons from "../elements/buttons.vue";
import utils from "./utils.js";

export default {
  name: "provider-page",
  components: {
    keyStats: keyStats,
    keyDescs: keyDescs,
    buttons: buttons
  },
  methods: {
    submit: function() {
      utils.post(this);
    }
  },
  beforeRouteLeave: function(to, from, next) {
    var self = this;
    utils.beforeRouteLeave(self, to, from, next);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/keyFactsPage.vue